import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class WebsocketService {
  private socket!: WebSocket;
  private messageSubject: Subject<any> = new Subject();

  constructor() {
    const token: string = localStorage.getItem('token') ?? '';
    let socketInit;
    if (token) {
      socketInit = new WebSocket(environment.socketIoUrl, [
        'Authorization',
        token,
      ]);
    } else {
      socketInit = new WebSocket(environment.socketIoUrl);
    }
    this.socket = socketInit;

    this.socket.onopen = () => {
      console.info('Connexion WebSocket ouverte');
    };

    this.socket.onmessage = (event: MessageEvent<any>) => {
      const data:any = event.data;
      const msg: string = JSON.parse(data);
      this.messageSubject.next(msg);
    };

    this.socket.onerror = (error: Event) => {
      console.error('Erreur WebSocket :', error);
    };

    this.socket.onclose = () => {
      console.info('Connexion WebSocket fermée');
    };
  }

  get messages$(): Observable<any> {
    return this.messageSubject.asObservable();
  }

  sendMessage(message: any): void {
    if (this.socket.readyState === WebSocket.OPEN) {
      this.socket.send(JSON.stringify({ ...message }));
    } else {
      console.error("Impossible d'envoyer, le socket n'est pas connecté.");
    }
  }

  disconnect(): void {
    if (this.socket) {
      this.socket.close();
    }
  }
}
